import {
	IconAB,
	IconBuildingStore,
	IconClock2,
	IconColorSwatch,
	IconExternalLink,
	IconHelp,
	IconList,
	IconListDetails,
	IconListNumbers,
	IconMail,
	IconMap,
	IconMap2,
	IconMessages,
	IconNotification,
	IconPackage,
	IconPictureInPicture,
	IconRectangleVertical,
	IconSettings,
	IconTags,
	IconTriangleSquareCircle,
	IconUsers,
	IconVersions,
	IconVideo,
} from '@tabler/icons';

const mobileAppConfigurations = {
	id: 'mobileAppConfigurations',
	title: 'Mobile App',
	type: 'group',
	children: [
		{
			id: 'end-users',
			title: 'Users management',
			type: 'item',
			url: '/end-users',
			icon: IconUsers,
		},

		{
			id: 'onboarding-question',
			title: 'Onboarding questions',
			type: 'item',
			url: '/onboarding-question',
			icon: IconHelp,
		},
		{
			id: 'regions-configuration',
			title: 'Regions lessons',
			type: 'collapse',
			icon: IconMap2,
			children: [
				{
					id: 'lessons',
					title: 'Lessons by region',
					type: 'item',
					url: '/list-of-regions',
					icon: IconAB,
				},
				{
					id: 'ListLessonCategories',
					title: 'Categories',
					type: 'item',
					url: '/lesson-categories',
					icon: IconTriangleSquareCircle,
				},
			],
		},
		{
			id: 'sentence',
			title: 'Sentences library',
			type: 'item',
			url: '/sentences',
			icon: IconAB,
		},
		{
			id: 'scene-matching',
			title: 'Scenes library',
			type: 'collapse',
			icon: IconPictureInPicture,
			children: [
				{
					id: 'scene-tags',
					title: 'Scene Tags',
					type: 'item',
					url: '/scene-matching/scene-tags',
					icon: IconTags,
				},
				{
					id: 'scene-cards',
					title: 'Scene Cards',
					type: 'item',
					url: '/scene-matching/scene-cards',
					icon: IconColorSwatch,
				},
				{
					id: 'scenes-groups',
					title: 'Scene Groups',
					type: 'item',
					url: '/scene-matching/scenes-groups',
					icon: IconPackage,
				},
			],
		},
		{
			id: 'live-session-cards',
			title: 'Live sessions - CTAs',
			type: 'item',
			url: '/live-session-cards',
			icon: IconExternalLink,
		},
		{
			id: 'guides',
			title: 'Guides',
			type: 'item',
			url: '/guides',
			icon: IconMessages,
		},
		{
			id: 'culture-card',
			title: 'Culture cards',
			type: 'collapse',
			icon: IconRectangleVertical,
			children: [
				{
					id: 'cards',
					title: 'List of cards',
					type: 'item',
					url: '/culture-card/cards',
					icon: IconListDetails,
				},
				{
					id: 'categories',
					title: 'Categories',
					type: 'item',
					url: '/culture-card/categories',
					icon: IconTriangleSquareCircle,
				},
			],
		},
		{
			id: 'shop',
			title: 'Souq',
			type: 'collapse',
			icon: IconBuildingStore,
			children: [
				{
					id: 'modules',
					title: 'Modules',
					type: 'item',
					url: '/shop/modules',
					icon: IconList,
				},
			],
		},
		{
			id: 'app-config',
			title: 'App configuration',
			type: 'collapse',
			icon: IconSettings,
			children: [
				{
					id: 'regions',
					title: 'Regions',
					type: 'item',
					icon: IconMap,
					url: '/app-config/regions',
				},
				{
					id: 'introduction-phases',
					title: 'Lessons types',
					type: 'item',
					url: '/app-config/introduction-phases',
					icon: IconVideo,
				},
				{
					id: 'verb-lesson-pronouns',
					title: 'Verb game pronouns',
					type: 'item',
					icon: IconAB,
					url: '/app-config/verb-lesson-pronouns',
				},
				{
					id: 'number-combination-config',
					title: 'Number combination',
					type: 'item',
					icon: IconListNumbers,
					url: '/app-config/number-combination-config',
				},
				{
					id: 'time-combination-config',
					title: 'Time voices',
					type: 'item',
					icon: IconClock2,
					url: '/app-config/time-combination-config',
				},
				{
					id: 'app-platforms-versions',
					title: 'Platform versions',
					type: 'item',
					icon: IconVersions,
					url: '/app-config/app-platforms-versions',
				},
			],
		},
		{
			id: 'notifications',
			title: 'Notifications',
			type: 'item',
			url: '/notification',
			icon: IconNotification,
		},
		{
			id: 'mails',
			title: 'Mails',
			type: 'item',
			url: '/mails',
			icon: IconMail,
		},
	],
};

export default mobileAppConfigurations;
